import React from "react";
import PropTypes from "prop-types";
import cname from "./style.module.scss";
import { useIntl } from "react-intl";
import { HighlightHTML } from "@learningblocks/storybook-components";

export function NoteBanner({ title, text, openGlossary, getGlossaryItem }) {
  const intl = useIntl();
  title = title
    ? intl.formatMessage({
        id: title,
        defaultMessage: title,
        description: "",
      })
    : "";
  text = text
    ? intl.formatMessage({
        id: text,
        defaultMessage: text,
        description: "",
      })
    : "";
  return (
    <>
      <h5 className={cname.title}>
        <HighlightHTML
          key={title}
          content={title}
          getContentData={getGlossaryItem}
          openGlossary={openGlossary}
        />
      </h5>
      <p className={cname.text}>
        <HighlightHTML
          key={text}
          content={text}
          getContentData={getGlossaryItem}
          openGlossary={openGlossary}
        />
      </p>
    </>
  );
}

NoteBanner.propTypes = {
  /**
   * Title to display on top of banner
   */
  title: PropTypes.string,
  /**
   * Content to display in banner
   */
  text: PropTypes.string,
};

NoteBanner.defaultProps = {
  title: "",
  text: "",
};
